module.exports = __webpack_public_path__ + "static/DWI20_Reg_1700x1200_Sachsen-27ddd3d0e565665873fc7612fd50839a.jpeg";